import { getFromStorage, removeFromStorage } from "./storageService";

export const cleanupOnTabOrBrowserClose = () => {
    if (getFromStorage("firstTimeSignupRedirectBackUrl")) removeFromStorage("firstTimeSignupRedirectBackUrl");
};
